import { API } from '@/api';
import { fetcher, HTTPError } from '@/services/fetcher';
import { logger } from '@/services/fetcher/logger';

export type DeleteShipmentRestrictionRequestParams = {
  id: number;
};

const masterSettingsApi = fetcher.extend(() => ({
  prefixUrl: `${API.MASTER_SETTINGS}`,
}));

export const deleteShipmentRestriction = async (
  params: DeleteShipmentRestrictionRequestParams,
  { signal }: { signal?: AbortController['signal'] } = {},
): Promise<string> => {
  try {
    return await masterSettingsApi
      .delete('DeleteEarlyShipmentRestriction', {
        searchParams: params,
        signal,
      })
      .text();
  } catch (error) {
    if (error instanceof HTTPError) {
      logger.error(`Error: ${error.response.status}`);
    }
    throw error;
  }
};
